import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import ACTIONS from '../../actions';
import Utils from '../../../utils';
var initialState = {
  token: null,
  error: null,
  environmentName: null,
  microserviceId: null,
  microserviceServer: '',
  ecrionServer: '',
  disableAuthRedirect: false
};
export var authReducer = function authReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ACTIONS.AUTH_SET:
      {
        return _objectSpread({}, state, action.payload);
      }

    case ACTIONS.AUTH_SET_UNAUTHORIZED:
      {
        var error = Utils.getPrettyError(action.payload) || 'Unauthorized';
        return _objectSpread({}, state, {
          error: error
        });
      }

    default:
      return state;
  }
};
export default authReducer;